import { memo, useCallback, useState } from "react";

import { Button } from "ui/components/Button/Button";
import { TextField } from "ui/components/TextField/TextField";
import { ContactRepresentativeSearchFilterProps } from "./types";

const ContactRepresentativeSearchFilters: React.FC<ContactRepresentativeSearchFilterProps> = (
  props
) => {
  const { onAddNew, onSearchChange } = props;

  const [search, setSearch] = useState("");

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setSearch(e.target.value);
    onSearchChange(e.target.value);
  };

  const handleResetFormClick = useCallback(() => {
    setSearch("");
    onSearchChange("");
  }, []);

  return (
    <>
      <div className=" ">
        <div className="flex justify-between items-center gap-3">
          <div className="flex">
            <div className="mr-3">
              <TextField
                type="text"
                name="search"
                value={search}
                onChange={handleSearchChange}
                placeholder="Pretraži"
                startIcon="../media/icons/search.svg"
                cssClassName="bg-white"
              />
            </div>

            <div className="mr-3 flex items-center">
              <span
                onClick={handleResetFormClick}
                className="text-xs font-bold cursor-pointer text-gray-700"
              >
                RESET
              </span>
            </div>
          </div>
          <div className=" py-3 flex justify-end ">
            <Button
              variant="primary"
              children="Dodaj osobu"
              startIcon="/media/icons/plus.svg"
              onClick={onAddNew}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(ContactRepresentativeSearchFilters);
